import type { FilterOption } from '@ui/shared/util-filter';

export class CulturalKindMapper {
    public static getValues(): Array<FilterOption> {
        return [
            {
                value: 'offering',
                label: 'Kulturangebot',
            },
            {
                value: 'facility',
                label: 'Kulturinstitution oder -location',
            },
        ];
    }

    public static isFilterOfferings(kind?: string | null): boolean {
        return !kind || kind === 'offering';
    }

    public static isFilterFacility(kind?: string | null): boolean {
        return !kind || kind === 'facility';
    }
}
